"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_image_file_resizer_1 = __importDefault(require("react-image-file-resizer"));
exports.resizeFile = function (file) {
    return new Promise(function (resolve) {
        try {
            react_image_file_resizer_1.default.imageFileResizer(file, 1800, 1800, 'JPEG', 100, 0, function (uri) {
                resolve(uri.toString());
            }, 'base64');
        }
        catch (e) {
            resolve('File error');
        }
    });
};
exports.convertSizeToMB = function (bytes, decimals) {
    var sizeKB = bytes / 1024;
    var sizeMB = sizeKB / 1024;
    return parseFloat(sizeMB.toFixed(decimals));
};
//# sourceMappingURL=image-utils.js.map